<template>
  <MatrizRfmFaixasTable
    dimensao="frequencia"
    titulo="Frequência (F)"
    descricao="Considera a quantidade de pedidos realizados pelo cliente dentro do período analisado. Quanto maior a frequência, maior a pontuação."
    cardId="card-configuracao-frequencia"
    rotuloDe="De (pedidos)"
    rotuloAte="Até (pedidos)"
    placeholder="Ex.: 5"
    step="1"
    :faixas="faixas"
    :erros="erros"
    :classificacoes="classificacoes"
    :formatador="formatarPedidos"
    :regraFormatador="regra"
    @alterar="payload => $emit('alterar', payload)"
    @restaurar="$emit('restaurar')"
  />
</template>

<script>
import MatrizRfmFaixasTable from "./MatrizRfmFaixasTable";

export default {
  name: "MatrizRfmFrequencia",
  components: { MatrizRfmFaixasTable },
  props: {
    faixas: { type: Array, required: true },
    erros: { type: Array, default: () => [] }
  },
  data: () => ({
    classificacoes: {
      5: "Altíssima frequência",
      4: "Frequente",
      3: "Frequência média",
      2: "Ocasional",
      1: "Baixa frequência"
    }
  }),
  methods: {
    formatarPedidos(valor) {
      return `${valor} pedidos`;
    },
    regra(faixa) {
      if (faixa.semLimite) {
        return faixa.de === null ? "-" : `${faixa.de} pedidos ou mais`;
      }
      if (faixa.de === null || faixa.ate === null) return "-";
      return `${faixa.de} até ${faixa.ate} pedidos`;
    }
  }
};
</script>
